module.exports = __webpack_public_path__ + "static/ambrelle-min-80d878cefaba647183d6d4c5a1dba7e6.png";